module.exports = __webpack_public_path__ + "media/img/pages/companies/romande-energie-92f019fce5f887bbabfa9ef8f90d4a6e.png";